var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"n-alert",class:{
    'n-alert-warning': _vm.type === 'warning',
    'n-alert-info': _vm.type === 'info',
    'n-alert-danger': _vm.type === 'danger',
  }},[(_vm.hasIcon || _vm.icon)?_c('div',{staticClass:"flex items-center gap-x-4"},[(_vm.icon || _vm.selectedIcon)?_c('inline-svg',{staticClass:"h-5 w-5 flex-shrink-0",attrs:{"src":_vm.iconPath}}):_vm._e(),_c('span',[_vm._t("default")],2)],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }